module.exports = __webpack_public_path__ + "img/thumbnail.9d520ff2.png";